// VolcanoesAndRiftvalleys.js
import React, { useState } from 'react';

import { Container, Card } from 'react-bootstrap';
// Import your images here
import bannerImg from '../../../Assets/imagesssss/1/10008.jpg';
import vol1 from '../../../Assets/imagesssss/1/2.jpg';
import vol2 from '../../../Assets/imagesssss/1/2.jpg';
import vol3 from '../../../Assets/imagesssss/1/2.jpg';
import vol4 from '../../../Assets/imagesssss/1/2.jpg';
import vol5 from '../../../Assets/imagesssss/1/2.jpg';
import vol6 from '../../../Assets/imagesssss/1/2.jpg';
import rift1 from '../../../Assets/imagesssss/1/2.jpg';
import rift2 from '../../../Assets/imagesssss/1/2.jpg';
import rift3 from '../../../Assets/imagesssss/1/2.jpg';
import rift4 from '../../../Assets/imagesssss/1/2.jpg';
import rift5 from '../../../Assets/imagesssss/1/2.jpg';
import rift6 from '../../../Assets/imagesssss/1/2.jpg';
import styles from'./VolcanoesAndRiftvalleys.module.css';
const VolcanoesAndRiftvalleys = () => {
  const [scrollPosition1, setScrollPosition1] = useState(0);
  const [scrollPosition2, setScrollPosition2] = useState(0);

  const volcanoes = [
    {
      id: 1,
      title: "Erta Ale Volcano",
      description: "Dive Into the Earth's Fury: Explore Afar’s Hydrothermal Marvels!",
      image: vol1
    },
    {
      id: 2,
      title: "Dallol Volcano",
      description: "Bubbling Beauty: Experience the Power of Afar's Hydrothermal Springs.",
      image: vol2
    },
    {
      id: 3,
      title: "Ale Bagu",
      description: "Nature's Boiling Cauldron: Where Heat and Color Collide in Afar.",
      image: vol3
    },
    {
      id: 4,
      title: "Dubbre Volcano",
      description: "Witness the Earth’s Inner Workings at Afar's Geothermal Springs.",
      image: vol4
    },
    {
      id: 5,
      title: "Kurub Volcano",
      description: "Explore the Hot Springs of Afar: A Dance of Steam and Color.",
      image: vol5
    },
    {
      id: 6,
      title: "Dama Ale",
      description: "Feel the Heat and See the Color—Afar's Hydrothermal Springs Await!",
      image: vol6
    }
  ];

  const riftValleys = [
    {
      id: 7,
      title: "Danakil Depression",
      description: "Breathe in the Sulfur: Journey Through Afar’s Colorful Springs!",
      image: rift1
    },
    {
      id: 8,
      title: "Afar Triangle",
      description: "Afar’s Sulfur Springs: Nature's Vibrant Chemistry on Display.",
      image: rift2
    },
    {
      id: 9,
      title: "Lake Afdera",
      description: "Discover the Fiery Colors of Afar's Sulfur Springs—An Unforgettable Experience!",
      image: rift3
    },
    {
      id: 10,
      title: "Salt Plains",
      description: "Where Sulfur Meets Serenity: The Unique Springs of Afar.",
      image: rift4
    },
    {
      id: 11,
      title: "Awash Valley",
      description: "Explore the Spectrum of Color at Afar's Sulfur Springs.",
      image: rift5
    },
    {
      id: 12,
      title: "Yangudi Rassa",
      description: "Embrace the Earth’s Elements in the Enchanting Sulfur Springs of Afar.",
      image: rift6
    }
  ];

  const handleScroll = (direction, row) => {
    const scrollAmount = 300;
    if (row === 1) {
      const maxScroll = volcanoes.length * 300;
      setScrollPosition1(prev => {
        const newPosition = direction === 'left' 
          ? prev - scrollAmount 
          : prev + scrollAmount;
        if (newPosition < 0) return 0;
        if (newPosition > maxScroll) return maxScroll;
        return newPosition;
      });
    } else {
      const maxScroll = riftValleys.length * 300;
      setScrollPosition2(prev => {
        const newPosition = direction === 'left' 
          ? prev - scrollAmount 
          : prev + scrollAmount;
        if (newPosition < 0) return 0;
        if (newPosition > maxScroll) return maxScroll;
        return newPosition;
      });
    }
  };

  return (
    <div className={styles.volcanoesPage}>
      <div 
        className={styles.banner} 
        style={{ backgroundImage: `url(${bannerImg})` }}
      >
        <h1>Hydrothermal and Sulfur Springs</h1>
        <p>Discover the Vibrant Wonders of Afar's Hydrothermal and Sulfur Springs—Nature's Fiery Palette.</p>
      </div>

      <div className={styles.carouselSection}>
        <h2>Hydrothermal and Sulfur Springs</h2>
        <Container className={styles.descriptionContainer}>
          <Card className={styles.descriptionCard}>
            <Card.Body>
              <Card.Text>
                The Afar region is famous for its vibrant hydrothermal and sulfur springs...
              </Card.Text>
            </Card.Body>
          </Card>
        </Container>

        <div className={styles.carouselContainer}>
          <button 
            className={`${styles.scrollButton} ${styles.left}`} 
            onClick={() => handleScroll('left', 1)}
          >
            &#8249;
          </button>
          <div className={styles.cardsContainer}>
            <div 
              className={styles.cardsTrack} 
              style={{ transform: `translateX(-${scrollPosition1}px)` }}
            >
              {volcanoes.map(item => (
                <div className={styles.card} key={item.id}>
                  <div className={styles.cardImage}>
                    <img src={item.image} alt={item.title} />
                  </div>
                  <div className={styles.cardContent}>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <button 
            className={`${styles.scrollButton} ${styles.right}`} 
            onClick={() => handleScroll('right', 1)}
          >
            &#8250;
          </button>
        </div>

        {/* Repeat for other sections like Lakes */}
      </div>
    </div>
  );
};

export default VolcanoesAndRiftvalleys;